import { runDemo } from "../shared/demoRunner";
import { createRefractionScene } from "./scene";

runDemo({
    createScene: createRefractionScene,
});
